/* eslint-disable react/require-default-props */
import React from 'react';
import { ATTACHMENT_DOWNLOAD_MODE, startAnchorDownload } from './downloadMode';
/**
 * The Download link, in the one of three shapes the host asked for (see ATTACHMENT_DOWNLOAD_MODE).
 * Always a real link to `url`, so it works with no script, can be long-pressed, and reads as a
 * link to assistive technology; `programmatic` only changes what a plain click does.
 */
export function AttachmentDownloadLink({ url, fileName, mode, className, testId, children }) {
    const handleClick = (event) => {
        if (mode !== ATTACHMENT_DOWNLOAD_MODE.PROGRAMMATIC)
            return;
        event.preventDefault();
        startAnchorDownload(url, fileName);
    };
    return (React.createElement("a", { className: className, href: url, download: mode === ATTACHMENT_DOWNLOAD_MODE.NATIVE ? undefined : fileName, "data-testid": testId, onClick: handleClick }, children));
}
